import './footerContainer.css';
import {Row, Col} from 'react-bootstrap';

import React, {Component} from 'react';

class FooterContainer extends Component {
    render() {
        return (
            <Row className={`footer-container ${this.props.className}`}>
                <Col>
                    {this.props.children}
                </Col>
            </Row>
        );
    }
}

export default FooterContainer;